import { useState, useCallback } from 'react';

/**
 * Custom hook for handling timer expiry
 * @returns {Object} Object containing timerExpired state and handleTimeUp function
 */
export const useTimer = () => {
  const [timerExpired, setTimerExpired] = useState(false);
  
  const handleTimeUp = useCallback(() => {
    // Disable all inputs when time is up
    setTimerExpired(true);
  }, []);
  
  return { 
    timerExpired, 
    handleTimeUp 
  };
};
